// @ts-strict-ignore
import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { routerEffectsActions } from '../router/router.actions';
import { boardEffectsActions, boardFacadeActions } from './board.actions';
import { BoardState } from './board.types';

export const boardInitialState: BoardState = {
  board: null,
  boardLoading: false,
  boardLoadingError: false,
  boardSaving: false,
  boardLastSaved: null,
  boardSaveError: false,
};

export const boardReducer = createImmerReducer(
  boardInitialState,

  /**
   * Board Effects actions
   */
  on(boardEffectsActions.setBoard, (state, { board }) => ({
    ...state,
    board,
    boardLoading: false,
    boardLoadingError: false,
  })),
  on(boardEffectsActions.boardLoaded, (state) => ({
    ...state,
    boardLoading: false,
  })),
  on(boardEffectsActions.boardLoadingError, (state) => ({
    ...state,
    boardLoading: false,
    boardLoadingError: true,
  })),
  on(boardEffectsActions.boardSaveComplete, (state, { board }) => ({
    ...state,
    board,
    boardSaving: false,
    boardLastSaved: new Date(),
    boardSaveError: false,
  })),
  on(boardEffectsActions.boardSaveError, (state) => ({
    ...state,
    boardSaving: false,
    boardSaveError: true,
  })),
  on(boardEffectsActions.createReductionGoalComplete, (state, { boardReductionGoal }) => ({
    ...state,
    board: {
      ...state.board,
      boardSettings: {
        ...state.board.boardSettings,
        reductionGoals: [boardReductionGoal],
      },
    },
    boardLastSaved: new Date(),
    boardSaving: false,
    boardSaveError: false,
  })),
  on(boardEffectsActions.updateReductionGoalComplete, (state, { boardReductionGoal }) => ({
    ...state,
    board: {
      ...state.board,
      boardSettings: {
        ...state.board.boardSettings,
        reductionGoals: state.board.boardSettings.reductionGoals.map((r) =>
          r.id === boardReductionGoal.id ? boardReductionGoal : r
        ),
      },
    },
    boardLastSaved: new Date(),
    boardSaving: false,
    boardSaveError: false,
  })),
  on(boardEffectsActions.deleteReductionGoalComplete, (state, { boardReductionGoal }) => ({
    ...state,
    board: {
      ...state.board,
      boardSettings: {
        ...state.board.boardSettings,
        reductionGoals: state.board.boardSettings.reductionGoals.filter((r) => r.id !== boardReductionGoal.id),
      },
    },
    boardLastSaved: new Date(),
    boardSaving: false,
    boardSaveError: false,
  })),
  on(boardEffectsActions.boardDeleteComplete, (state) => ({
    ...state,
    boardSaving: false,
    boardSaveError: false,
  })),

  /**
   * Router Effects actions
   */
  on(routerEffectsActions.routeBoardIdChanged, (state) => {
    const wasBoardLoadedPreviously = !!state.board;
    return {
      ...boardInitialState,
      boardLoading: wasBoardLoadedPreviously,
    };
  }),

  /**
   * Board Facade actions
   */
  on(boardFacadeActions.loadBoard, (state) => ({
    ...state,
    boardLoading: true,
    boardLoadingError: false,
  })),
  on(boardFacadeActions.deleteBoard, (state) => ({
    ...state,
    boardSaving: true,
    boardSaveError: false,
  })),
  on(boardFacadeActions.saveBoard, (state, { updates }) => {
    return {
      ...state,
      boardSaving: !!updates?.length,
    };
  }),
  on(boardFacadeActions.createReductionGoal, (state) => ({
    ...state,
    boardLoading: true,
    boardLoadingError: false,
  })),
  on(boardFacadeActions.updateReductionGoal, (state) => ({
    ...state,
    boardLoading: true,
    boardLoadingError: false,
  })),
  on(boardFacadeActions.deleteReductionGoal, (state) => ({
    ...state,
    boardLoading: true,
    boardLoadingError: false,
  })),
  on(boardFacadeActions.updateETagAndChildNodes, (state, { _etag, childNodes }) => ({
    ...state,
    board: {
      ...state.board,
      _etag,
      childNodes,
    },
  })),
  on(boardFacadeActions.clearBoardStore, () => boardInitialState)
);
